/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_MENU (state, menu) {
    state.menu = menu
  },
  REMOVE_RECORD (state, itemId) {
    const mailtplIndex = state.mailtpls.findIndex((u) => u.id === itemId)
    state.mailtpls.splice(mailtplIndex, 1)
  }
}
